import { Builder } from '@builder.io/react'
import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import LinkButton, { LinkButtonProp } from '../common/button'
import './reviews-section.css'
import CdnImage from 'components/util/CdnImage'
import { triggerTagging } from 'components/util/common-utils'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { HeadingClass, HeadingType } from 'enums'
import { StaticImage } from 'gatsby-plugin-image'
import CustomHeading, { headingTypePropObj } from '../common/heading'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}
interface Step {
  // cloudinaryImage: any
  builderImage: any
  imageAltText: string
  descriptionTitleText: string
  descriptionTitleTextAlignment: Alignment
  descriptionText: string
  descriptionTextAlignment: Alignment
  stepBackgroundColor: string
  optimalImgEnable: boolean
  signature: string
}
interface Props {
  backgroundColor: string
  steps: Step[]
  stepDescriptionTitleTextColor: string
  stepDescriptionTextColor: string
  buttonOneProp: LinkButtonProp
  buttonEnabled: boolean
  optionalImage: boolean
  // cloudinaryOptionalImage: any
  builderOptionalImage: any
  optionalImageAltText: string
  imageProperty: string
  imageOrientation: 'landscape' | 'portrait'
  footerText: string
  footerTextColor: string
  footerTextAlignment: Alignment
  footerType: HeadingType
  footerClass: HeadingClass
  footerAdditionalText: string
}

function SamplePrevArrowDesktop(props: any) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'flex',
        justifyContent: 'center',
        zIndex: 2,
        left: '-14px !important',
        top: '50% !imporatant',
        transform: 'translateY(-50%) !important'
      }}
      onClick={onClick}
    />
  )
}

function SampleNextArrowDesktop(props: any) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'flex',
        justifyContent: 'center',
        zIndex: 2,
        right: '-14px !important',
        top: '50% !imporatant',
        transform: 'translateY(-50%) !important'
      }}
      onClick={onClick}
    />
  )
}

const settingsDesktop = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrowDesktop />,
  prevArrow: <SamplePrevArrowDesktop />
}

const ReviewsSection = ({
  backgroundColor,
  steps,
  stepDescriptionTitleTextColor,
  stepDescriptionTextColor,
  buttonOneProp,
  buttonEnabled = true,
  optionalImage,
  // cloudinaryOptionalImage,
  builderOptionalImage,
  optionalImageAltText = '',
  imageProperty,
  imageOrientation,
  footerText,
  footerTextColor,
  footerTextAlignment,
  footerType,
  footerClass,
  footerAdditionalText
}: Props) => {
  const [turboRouteComponent, setTurboRouteComponent] = useState<HTMLElement | null>(null)

  const [currentSlide, setCurrentSlide] = useState(0)
  const [totalSlides, setTotalSlides] = useState(0)

  const handleAfterChange = (current: number) => {
    setCurrentSlide(current)
  }

  const SamplePrevArrow = (props: any) => {
    const { style, onClick, disabled } = props
    return (
      <div
        id="reviewArrowRight"
        style={{
          ...style,
          display: 'inline-flex',
          justifyContent: 'center',
          zIndex: 2,
          transform: 'translateY(-50%)',
          width: '1.6rem',
          height: '1.6rem',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto'
        }}
        onClick={disabled ? undefined : onClick}
      >
        <StaticImage className="w-8" src={'../../../../images/dog-details/dog-details-back.svg'} alt="Chevron left" />
      </div>
    )
  }

  const SampleNextArrow = (props: any) => {
    const { style, onClick, disabled } = props
    return (
      <div
        id="reviewArrowLeft"
        style={{
          ...style,
          display: 'inline-flex',
          justifyContent: 'center',
          zIndex: 2,
          transform: 'translateY(-50%)',
          width: '1.6rem',
          height: '1.6rem',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto'
        }}
        onClick={disabled ? undefined : onClick}
      >
        <StaticImage
          className="w-8 rotate-180"
          src={'../../../../images/dog-details/dog-details-back.svg'}
          alt="Chevron right"
        />
      </div>
    )
  }

  const settingsMobile = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    beforeChange: (current: number, next: number) => {
      setCurrentSlide(next)
    },
    afterChange: handleAfterChange,
    prevArrow: <SamplePrevArrow disabled={currentSlide === 0} />,
    nextArrow: <SampleNextArrow disabled={currentSlide === totalSlides - 1} />,
    onInit: (slider: any) => {
      if (slider && slider.slideCount !== undefined) {
        setTotalSlides(slider.slideCount)
      }
    },
    onReInit: (slider: any) => {
      if (slider && slider.slideCount !== undefined) {
        setTotalSlides(slider.slideCount)
      }
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const turboRoute = document.querySelector('#turboRoute')
      if (turboRoute) {
        setTurboRouteComponent(turboRoute as HTMLElement)
      }
    }
  }, [])

  const getAlignmentClass = (textAlignment: any) => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  function getImgOrientation() {
    if (imageOrientation === 'landscape') {
      return 'h-44'
    }
    return 'h-60'
  }

  const stepSignaturesStandard = [0, 1, 2]

  return (
    <>
      <div className="m-auto w-full" style={{ backgroundColor }}>
        <div className="mx-auto max-w-7xl py-5 sm:px-2 sm:py-10 lg:px-4">
          {/* ================= Mobile Slider start */}
          <div className="relative flex justify-center md:hidden">
            <Slider {...settingsMobile} style={{ width: '85%' }}>
              {steps?.map((step: Step, i: number) => (
                <div key={i} className="mx-auto !flex h-full max-w-sm justify-center">
                  <div
                    className="mx-2 my-0 flex w-full flex-col rounded-2xl"
                    style={{ backgroundColor: step?.stepBackgroundColor || '#FFFFFF', borderRadius: '2rem' }}
                  >
                    <div className={`w-full sm:flex-shrink-0 ${getImgOrientation()}`}>
                      <CdnImage
                        className={`${imageProperty} block max-h-[120px] w-full rounded-t-3xl object-cover xs:min-h-[120px] md:max-h-full`}
                        url={step.builderImage}
                        alt={step.imageAltText}
                        steps={[400, 300]}
                        style={{
                          width: '400px',
                          height: '280px',
                          maxHeight: '100%',
                          maxWidth: '100%'
                        }}
                      />
                      {/* {step.builderImage ? (
                        <CdnImage
                          className={`${imageProperty} block max-h-[120px] w-full rounded-t-3xl object-cover xs:min-h-[120px] md:max-h-full`}
                          url={step.builderImage}
                          alt={step.imageAltText}
                          steps={[400, 300]}
                          style={{
                            width: '400px',
                            height: '280px',
                            maxHeight: '100%',
                            maxWidth: '100%'
                          }}
                        />
                      ) : (
                        <CloudinaryImage
                          className={`${imageProperty} block max-h-[120px] w-full rounded-t-3xl object-cover xs:min-h-[120px] md:max-h-full`}
                          publicId={step.cloudinaryImage?.public_id}
                          alt={step.imageAltText}
                          steps={[400, 300]}
                          style={{
                            width: '400px',
                            height: '280px',
                            maxHeight: '100%',
                            maxWidth: '100%'
                          }}
                        />
                      )} */}
                    </div>
                    <div className="flex h-full flex-col p-6 items-center">
                      <div>
                        <p
                          className={` enable-list-styles my-1 break-words text-base `}
                          dangerouslySetInnerHTML={{ __html: step.descriptionTitleText }}
                          style={{ color: stepDescriptionTitleTextColor }}
                        ></p>
                        <p
                          className={`enable-list-styles mt-2 break-words text-base !font-sans ${getAlignmentClass(
                            step.descriptionTextAlignment
                          )}`}
                          dangerouslySetInnerHTML={{ __html: step.descriptionText }}
                          style={{ color: stepDescriptionTextColor }}
                        ></p>
                        <div className="relative bottom-0 mx-auto mb-10 w-full items-center justify-center">
                          {stepSignaturesStandard.includes(i) && (
                            <p
                              className={`enable-list-styles font-third relative bottom-8 -right-16 sm:right-1 break-words text-center text-3xl`}
                              dangerouslySetInnerHTML={{ __html: step.signature }}
                              style={{ color: stepDescriptionTextColor }}
                            ></p>
                          )}
                          {!stepSignaturesStandard.includes(i) && i === 3 && (
                            <p
                              className={`enable-list-styles font-third relative bottom-8 -right-6 xs:right-0 sm:right-32 break-words text-right text-3xl`}
                              style={{ color: stepDescriptionTextColor }}
                              dangerouslySetInnerHTML={{ __html: step.signature }}
                            ></p>
                          )}
                          {!stepSignaturesStandard.includes(i) && i === 4 && (
                            <p
                              className={`enable-list-styles font-third relative bottom-16 -right-6 xs:right-0 sm:right-32 break-words text-right text-3xl`}
                              style={{ color: stepDescriptionTextColor }}
                              dangerouslySetInnerHTML={{ __html: step.signature }}
                            ></p>
                          )}
                          {!stepSignaturesStandard.includes(i) && i === 5 && (
                            <p
                              className={`enable-list-styles font-third relative bottom-6 -right-20 xs:right-8 break-words text-right text-3xl w-full`}
                              style={{ color: stepDescriptionTextColor }}
                              dangerouslySetInnerHTML={{ __html: step.signature }}
                            ></p>
                          )}
                        </div>
                      </div>
                      {optionalImage && step?.optimalImgEnable && (
                        <div className="absolute bottom-8">
                          <div className="mx-auto flex w-full">
                            <CdnImage
                              url={builderOptionalImage}
                              alt={optionalImageAltText}
                              steps={[120]}
                              style={{
                                width: '120px',
                                height: '55px',
                                maxHeight: '100%',
                                maxWidth: '100%'
                              }}
                            />
                            {/* {builderOptionalImage ? (
                              <CdnImage
                                url={builderOptionalImage}
                                alt={optionalImageAltText}
                                steps={[120]}
                                style={{
                                  width: '120px',
                                  height: '55px',
                                  maxHeight: '100%',
                                  maxWidth: '100%'
                                }}
                              />
                            ) : (
                              <CloudinaryImage
                                publicId={cloudinaryOptionalImage?.public_id}
                                alt={optionalImageAltText}
                                steps={[120]}
                                style={{
                                  width: '120px',
                                  height: '55px',
                                  maxHeight: '100%',
                                  maxWidth: '100%'
                                }}
                              />
                            )} */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          {/* ================= Mobile Slider End*/}

          {/* ============ Desktop slider for >=5 card Start =============*/}
          <div className="hidden md:flex md:justify-center">
            <Slider {...settingsDesktop} style={{ width: '95%' }}>
              {steps?.map((step: Step, i: number) => (
                <div key={i} className="mx-auto !flex h-full !w-11/12">
                  <div
                    className="mx-2 flex w-full flex-col rounded-2xl"
                    style={{ backgroundColor: step?.stepBackgroundColor || '#FFFFFF', borderRadius: '2rem' }}
                  >
                    <div className={`w-full sm:flex-shrink-0 ${getImgOrientation()}`}>
                      <CdnImage
                        className={`${imageProperty} block max-h-[120px] w-full rounded-t-3xl object-cover xs:min-h-[120px] md:max-h-full`}
                        url={step.builderImage}
                        alt={step.imageAltText}
                        steps={[400, 300]}
                        style={{
                          height: '300px',
                          maxHeight: '100%',
                          maxWidth: '100%'
                        }}
                      />
                      {/* {step.builderImage ? (
                        <CdnImage
                          className={`${imageProperty} block max-h-[120px] w-full rounded-t-3xl object-cover xs:min-h-[120px] md:max-h-full`}
                          url={step.builderImage}
                          alt={step.imageAltText}
                          steps={[400, 300]}
                          style={{
                            height: '300px',
                            maxHeight: '100%',
                            maxWidth: '100%'
                          }}
                        />
                      ) : (
                        <CloudinaryImage
                          className={`${imageProperty} block max-h-[120px] w-full rounded-t-3xl object-cover xs:min-h-[120px] md:max-h-full`}
                          publicId={step.cloudinaryImage?.public_id}
                          alt={step.imageAltText}
                          steps={[400, 300]}
                          style={{
                            height: '300px',
                            maxHeight: '100%',
                            maxWidth: '100%'
                          }}
                        />
                      )} */}
                    </div>
                    <div className="flex h-full flex-col p-6 items-center">
                      <div className="mb-2">
                        <p
                          className={` enable-list-styles my-1 break-words text-base ${getAlignmentClass(
                            step.descriptionTitleTextAlignment
                          )}`}
                          dangerouslySetInnerHTML={{ __html: step.descriptionTitleText }}
                          style={{ color: stepDescriptionTitleTextColor }}
                        ></p>
                        <p
                          className={`enable-list-styles mt-2 break-words text-base !font-sans ${getAlignmentClass(
                            step.descriptionTextAlignment
                          )}`}
                          dangerouslySetInnerHTML={{ __html: step.descriptionText }}
                          style={{ color: stepDescriptionTextColor }}
                        ></p>
                        {stepSignaturesStandard.includes(i) && (
                          <p
                            className={`enable-list-styles font-third relative bottom-6 md:-right-32 break-words text-left text-3xl pb-4`}
                            style={{ color: stepDescriptionTextColor }}
                            dangerouslySetInnerHTML={{ __html: step.signature }}
                          ></p>
                        )}
                        {!stepSignaturesStandard.includes(i) && i === 3 && (
                          <p
                            className={`enable-list-styles font-third relative bottom-6 md:-right-32 break-words text-left text-3xl`}
                            style={{ color: stepDescriptionTextColor }}
                            dangerouslySetInnerHTML={{ __html: step.signature }}
                          ></p>
                        )}
                        {!stepSignaturesStandard.includes(i) && i === 4 && (
                          <p
                            className={`enable-list-styles font-third relative bottom-[3.5rem] md:-right-32 break-words text-left text-3xl`}
                            style={{ color: stepDescriptionTextColor }}
                            dangerouslySetInnerHTML={{ __html: step.signature }}
                          ></p>
                        )}
                        {!stepSignaturesStandard.includes(i) && (i === 5 || i === 6) && (
                          <p
                            className={`enable-list-styles font-third relative bottom-[3.5rem] md:-right-24 break-words text-left text-3xl md:w-2/3 lg:w-1/2`}
                            style={{ color: stepDescriptionTextColor }}
                            dangerouslySetInnerHTML={{ __html: step.signature }}
                          ></p>
                        )}
                      </div>
                      {optionalImage && step?.optimalImgEnable && (
                        <div className="absolute bottom-8">
                          <div className="mx-auto"></div>
                          <div className="mx-auto w-full">
                            <CdnImage
                              url={builderOptionalImage}
                              alt={optionalImageAltText}
                              steps={[120]}
                              style={{
                                // width: '120px',
                                height: '55px',
                                maxHeight: '100%',
                                maxWidth: '100%'
                              }}
                            />
                            {/* {builderOptionalImage ? (
                              <CdnImage
                                url={builderOptionalImage}
                                alt={optionalImageAltText}
                                steps={[120]}
                                style={{
                                  // width: '120px',
                                  height: '55px',
                                  maxHeight: '100%',
                                  maxWidth: '100%'
                                }}
                              />
                            ) : (
                              <CloudinaryImage
                                publicId={cloudinaryOptionalImage?.public_id}
                                alt={optionalImageAltText}
                                steps={[120]}
                                style={{
                                  // width: '120px',
                                  height: '55px',
                                  maxHeight: '100%',
                                  maxWidth: '100%'
                                }}
                              />
                            )} */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          {/* =============== Desktop slider for >=5 card End =============== */}

          <div
            className={`mx-auto flex w-full flex-col justify-center px-4 ${!footerText && !buttonEnabled ? '' : 'pt-10'} text-center lg:w-2/3`}
            style={{ backgroundColor }}
          >
            {footerText && (
              <CustomHeading
                classList="text-center"
                headingClass={footerClass}
                headingType={footerType}
                color={footerTextColor}
              >
                {footerText}
              </CustomHeading>
            )}
            {footerAdditionalText && (
              <p
                className={`enable-list-styles mt-6 mb-4 w-full text-left text-lg lg:ml-0 lg:text-center font-sans font-normal`}
                dangerouslySetInnerHTML={{ __html: footerAdditionalText }}
              ></p>
            )}
            {buttonEnabled && (
              <div className={`${footerAdditionalText || footerText ? 'mt-6' : ''}`}>
                {turboRouteComponent ? (
                  <button
                    className={
                      'px-5 py-3 border border-transparent text-base font-medium rounded-full md:py-4 md:text-lg md:px-10 w-full md:w-3/5 mx-auto'
                    }
                    style={{ backgroundColor: buttonOneProp.buttonColor, color: buttonOneProp.buttonTextColor }}
                    onClick={() => {
                      triggerTagging('reviews_section_cta_turbo_route', 'turbo_route')
                      turboRouteComponent.scrollIntoView({ behavior: 'smooth', block: 'start' })
                    }}
                  >
                    Get Started
                  </button>
                ) : (
                  <>
                    <LinkButton
                      buttonColor={buttonOneProp.buttonColor}
                      buttonUrl={buttonOneProp.buttonUrl}
                      buttonText={buttonOneProp.buttonText}
                      loggedInButtonText={buttonOneProp.loggedInButtonText}
                      buttonTextColor={buttonOneProp.buttonTextColor}
                      isLink={false}
                      classList={
                        'px-5 py-3 mt-4 border border-transparent text-base font-medium rounded-full md:py-4 md:text-lg md:px-10 w-full md:w-3/5 mx-auto'
                      }
                    />
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ReviewsSection

Builder.registerComponent(ReviewsSection, {
  name: 'ReviewsSection',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'stepDescriptionTitleTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'stepDescriptionTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'steps',
      type: 'list',
      defaultValue: [
        {
          imageSrc: null,
          imageAltText: '',
          descriptionTitleText: 'Step one Title',
          descriptionTitleTextAlignment: 'left',
          descriptionText: 'Step one Description',
          descriptionTextAlignment: 'left',
          stepBackgroundColor: '#F9F5F1',
          optimalImgEnable: true,
          signature: ''
        }
      ],
      subFields: [
        // { name: 'cloudinaryImage', type: 'cloudinaryImageEditor' },
        {
          name: 'builderImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },

        { name: 'imageAltText', type: 'text', defaultValue: '' },
        { name: 'descriptionTitleText', type: 'richText', defaultValue: 'Step one Title' },
        {
          name: 'descriptionTitleTextAlignment',
          type: 'string',
          enum: ['left', 'center', 'right'],
          defaultValue: 'left'
        },
        { name: 'descriptionText', type: 'richText', defaultValue: 'Step one description' },
        { name: 'descriptionTextAlignment', type: 'string', enum: ['left', 'center', 'right'], defaultValue: 'left' },
        { name: 'stepBackgroundColor', type: 'color', defaultValue: '#F9F5F1' },
        { name: 'optimalImgEnable', type: 'boolean', defaultValue: true },
        { name: 'signature', type: 'richText', defaultValue: 'Signature' }
      ]
    },
    {
      name: 'optionalImage',
      type: 'boolean',
      defaultValue: true
    },
    // { name: 'cloudinaryOptionalImage', type: 'cloudinaryImageEditor' },
    {
      name: 'builderOptionalImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },

    {
      name: 'optionalImageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'buttonOneProp',
      type: 'object',
      defaultValue: {
        buttonColor: 'white',
        buttonText: 'Create Your Plan',
        buttonTextColor: 'black',
        buttonUrl: '#',
        isLink: false
      },
      subFields: [
        { name: 'buttonColor', type: 'color', defaultValue: 'white' },
        { name: 'buttonText', type: 'string', defaultValue: 'Create Your Plan' },
        { name: 'loggedInButtonText', type: 'string', defaultValue: 'Logged In' },
        { name: 'buttonTextColor', type: 'color', defaultValue: 'black' },
        { name: 'buttonUrl', type: 'text', defaultValue: '#' },
        { name: 'isLink', type: 'boolean', defaultValue: false }
      ]
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'imageProperty',
      type: 'string',
      enum: ['object-contain', 'object-cover'],
      defaultValue: 'object-cover'
    },
    {
      name: 'imageOrientation',
      type: 'text',
      enum: ['landscape', 'portrait'],
      defaultValue: 'portrait'
    },
    {
      ...headingTypePropObj
    },
    {
      name: 'footerClass',
      type: 'string',
      enum: ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
      defaultValue: 'H1'
    },
    {
      name: 'footerText',
      type: 'string',
      defaultValue: 'Sample Footer'
    },
    {
      name: 'footerTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'footerAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'center'
    },
    {
      name: 'footerAdditionalText',
      type: 'richText',
      defaultValue: ''
    }
  ]
})
